import { useMutation, useQuery } from '@tanstack/react-query';
import useTranslate from '../../Hooks/useTranslate';
import notify from '../../Style-guide/ToastMessage';
import { deleteData, getData, sendData, updateData } from '../fetchers';

export const useCreateUserMutation = () =>
  useMutation({
    mutationFn: ({ data, params, queryParams }) =>
      sendData('users', data, params, queryParams),
  });

export const useGetUserQuery = (params) =>
  useQuery({
    queryKey: ['users', params?.params],
    queryFn: () => getData('users/:id', params?.params),
    retry: 0,
    select: (data) => data?.data,
    ...params,
  });

export const useUpdateUserMutation = () => {
  const tr = useTranslate();

  return useMutation({
    mutationFn: ({ data, params, queryParams }) =>
      updateData('users/:id', data, params, queryParams),
    onSuccess: (data) => notify.success(tr(data?.translationKey) || data?.message),
  });
};

export const useDeleteUserMutation = () => {
  const tr = useTranslate();

  return useMutation({
    mutationFn: ({ data, params, queryParams }) =>
      deleteData('users/:id', data, params, queryParams),
    onSuccess: (data) => notify.success(tr(data?.translationKey) || data?.message),
  });
};
